<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okDisabled="true"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empEntranceManager.managerWorkNo']">
              <a-input  v-model="queryParam.managerWorkNo"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empEntranceManager.status']">
              <!--<a-input placeholder="请输入入口名称" v-model="queryParam.entranceName"></a-input>-->
              <j-dict-select-tag type="list" v-model="queryParam.status" dictCode="entrance_manager_status"   allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="handleAdd" v-has="'cmscol:managerInsert'" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
    </div>
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        {{language['emp.cmscol.manager.title']}}
      </div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="isShowSetBtn?columns:baseColumns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{x:true}"><!-- :scroll="{x:true}" -->

        <span slot="action" slot-scope="text, record">
            <a @click="handleSetting(record)" v-has="'cmscol:managerSet'" v-if="isShowSetBtn">{{language['emp.cmscol.manager.set']}}</a>
          <a-divider type="vertical" v-if="isShowSetBtn" />
            <a @click="handleFrozen(record,'1')" v-has="'cmscol:managerFreeze'" v-if="record.status=='0'">{{language['sys.dict.status.freeze']}}</a>
            <a @click="handleFrozen(record,'0')" v-has="'cmscol:managerFreeze'" v-if="record.status!='0'">{{language['common.thawButton']}}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="language['common.deleteConfirmInfo']" v-has="'cmscol:managerDelete'"  @confirm="() => remove(record)">
                <a>{{language['common.delete']}}</a>
            </a-popconfirm>
        </span>

        <template slot="legalperson" slot-scope="text, record, index">
          <a-tooltip :title="record.legalperson" placement="topLeft" :disabled="false">
            <span>{{!text?"":(text.length>20?text.substr(0,20)+"...":text)}}</span>
          </a-tooltip>
        </template>

      </a-table>
    </div>
    <div class="table-operator">
      <a-button @click="handleAdd2" v-has="'cmscol:managerInsert'" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
    </div>
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        {{language['emp.cmscol.approver.title']}}
      </div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns2"
        :dataSource="dataSource2"
        :pagination="ipagination2"
        :loading="loading2"
        @change="handleTableChange2"
        :scroll="{x:true}"><!-- :scroll="{x:true}" -->

        <span slot="action" slot-scope="text, record">
            <a @click="handleFrozen2(record,'1')" v-has="'cmscol:managerFreeze'" v-if="record.status=='0'">{{language['sys.dict.status.freeze']}}</a>
            <a @click="handleFrozen2(record,'0')" v-has="'cmscol:managerFreeze'" v-if="record.status!='0'">{{language['common.thawButton']}}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="language['common.deleteConfirmInfo']" v-has="'cmscol:managerDelete'"  @confirm="() => remove2(record)">
                <a>{{language['common.delete']}}</a>
            </a-popconfirm>
        </span>

      </a-table>
    </div>
    <cms-col-manager-user-modal ref="userModal" @ok="searchQuery"/>
    <cms-col-approver-user-modal ref="userModal2" @ok="searchQuery"/>
    <cms-col-tbl-manager-legalperson-modal ref="legalpersonModal" @ok="searchQuery"></cms-col-tbl-manager-legalperson-modal>
  </j-modal>
</template>

<script>
  import { getAction,putAction,deleteAction } from '@/api/manage'
  import CmsColManagerUserModal from './CmsColManagerUserModal'
  import CmsColApproverUserModal from './CmsColApproverUserModal'
  import CmsColTblManagerLegalpersonModal from "./CmsColTblManagerLegalpersonModal";
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { filterObj } from '@/utils/util'
    export default {
      components: {
        CmsColManagerUserModal,
        CmsColApproverUserModal,
        CmsColTblManagerLegalpersonModal
      },
      name: "CmsColTblManagerModal",
      mixins:[JeecgListMixin],
      data () {
        return {
          queryParam:{colId:""},
          colId:"",
          dataSource:[],
          dataSource2:[],
          loading2: false,
          columns:[
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerWorkNo'],
              align:"center",
              dataIndex: 'managerWorkNo',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerName'],
              align:"center",
              dataIndex: 'managerName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.status'],
              align:"center",
              dataIndex: 'status_dictText'
            },
            /*{
              title:this.$store.getters.language['emp.empEntranceManager.createTime'],
              align:"left",
              dataIndex: 'createTime',
              customRender:function (text,r) {
                return !text?"":(text.length>10?text.substr(0,10):text)
              }
            },*/
            {
              title:this.$store.getters.language['emp.cmscol.manager.legalperson'],
              align:"center",
              dataIndex: 'legalpersonNames',
              width:300,
              scopedSlots: {customRender: 'legalperson'},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ],
          baseColumns:[
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerWorkNo'],
              align:"center",
              dataIndex: 'managerWorkNo',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerName'],
              align:"center",
              dataIndex: 'managerName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.status'],
              align:"center",
              dataIndex: 'status_dictText'
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ],
          title:this.$store.getters.language['emp.empCmsEntrance.managers'],
          width:1200,
          visible: false,
          disableSubmit: false,
          url: {
            list: "/hhemp/colManager/list",
            list2: "/hhemp/colApprover/list"
          },
          columns2:[
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerWorkNo'],
              align:"center",
              dataIndex: 'approverWorkNo',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerName'],
              align:"center",
              dataIndex: 'approverName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.status'],
              align:"center",
              dataIndex: 'status_dictText'
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ],
          ipagination2: {
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '15', '20'],
            showTotal: (total, range) => {
              return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
          },
          isorter2: {
            column: 'createTime',
            order: 'desc'
          },
          filters2: {},
          showSetFlag: false
        }
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        isShowSetBtn() {
          if(this.$store.getters.applicationCode=='hhemp'){
            return true
          }else{
            return false
          }
        },
      },
      methods: {
        add () {
          this.visible=true
          this.$nextTick(()=>{
            this.$refs.realForm.add();
          })
        },
        edit (record) {
          this.visible=true
          this.queryParam.colId = record.id
          this.colId = record.id
          this.searchQuery()
        },
        close () {
          this.$emit('close');
          this.visible = false;
        },
        handleOk () {
          this.$refs.realForm.submitForm();
        },
        submitCallback(){
          this.$emit('ok');
          this.visible = false;
        },
        handleCancel () {
          this.close()
        },
        searchQuery(){
          this.dataSource = []
          this.dataSource2 = []
          getAction("/hhemp/colManager/list",this.queryParam).then(res=>{
            if(res.success){
              this.dataSource = res.result;
            }
          })
          getAction("/hhemp/colApprover/list",this.queryParam).then(res=>{
            if(res.success){
              this.dataSource2 = res.result;
            }
          })
        },
        searchReset(){
          this.queryParam.managerWorkNo = '';
          this.queryParam.status = '';
          this.loadData(1);
          this.loadData2(1);
        },
        handleAdd(){
          let list = [];
          if(this.dataSource!=null && this.dataSource.length>0){
            this.dataSource.forEach(item=>{
              let map = {};
              map.id = item.managerId;
              map.workNo = item.managerWorkNo
              map.realname = item.managerName
              map.disableFlag = "1"
              list.push(map);
            })
          }
          this.$refs.userModal.edit(list,this.colId)
        },
        handleAdd2(){
          let list = [];
          if(this.dataSource2!=null && this.dataSource2.length>0){
            this.dataSource2.forEach(item=>{
              let map = {};
              map.id = item.approverId;
              map.workNo = item.approverWorkNo
              map.realname = item.approverName
              map.disableFlag = "1"
              list.push(map);
            })
          }
          this.$refs.userModal2.edit(list,this.colId)
        },
        handleFrozen(record,v){
          record.status = v;
          putAction("/hhemp/colManager/empcolmanager",record).then(res=>{
            if(res.success){
              this.searchQuery();
            }
          })
        },
        handleFrozen2(record,v){
          record.status = v;
          putAction("/hhemp/colApprover/empcolapprover",record).then(res=>{
            if(res.success){
              this.searchQuery();
            }
          })
        },
        remove(record){
          deleteAction("/hhemp/colManager/empcolmanager",{id:record.id}).then(res=>{
            if(res.success){
              this.searchQuery();
            }
          })
        },
        remove2(record){
          deleteAction("/hhemp/colApprover/empcolapprover",{id:record.id}).then(res=>{
            if(res.success){
              this.searchQuery();
            }
          })
        },
        handleSetting(record){
          this.$refs.legalpersonModal.appTypeSet(record.id);
          this.$refs.legalpersonModal.title = this.language['emp.cmscol.manager.set'] + this.language['emp.cmscol.manager.legalperson'];
        },
        handleTableChange2(pagination, filters, sorter) {
          //分页、排序、筛选变化时触发
          //TODO 筛选
          if (Object.keys(sorter).length > 0) {
            this.isorter2.column = sorter.field
            this.isorter2.order = 'ascend' == sorter.order ? 'asc' : 'desc'
          }
          this.ipagination2 = pagination
          this.loadData2()
        },
        loadData2(arg) {
          if (!this.url.list2) {
            this.$message.error(this.language['platform.roleUser.pleaseSeturl.list2Status'])
            return
          }
          //加载数据 若传入参数1则加载第一页的内容
          if (arg === 1) {
            this.ipagination2.current = 1
          }
          let params = this.getQueryParams2()
          this.loading2 = true
          getAction(this.url.list2, params).then((res) => {
            if (res.success) {
              this.dataSource2 = res.result
              this.ipagination2.total = res.result.total

            }
            this.loading2 = false
          })

        },
        getQueryParams2() {
          //获取查询条件
          let sqp = {}
          var param = Object.assign(sqp, this.queryParam, this.isorter2, this.filters2)
          param.pageNo = this.ipagination2.current
          param.pageSize = this.ipagination2.pageSize
          return filterObj(param)
        },

      }
    }
</script>

<style scoped>

</style>